import type { FC } from "react";
import useRemediationItemsSplit from "../General/useRemediationItemsSplit";
import ClassicAppHeader from "./ClassicAppHeader/ClassicAppHeader";
import GroupedAppHeader from "./GroupedAppHeader/GroupedAppHeader";

const AppHeader: FC = () => {
  const isRemediationItemsSplit = useRemediationItemsSplit();

  if (isRemediationItemsSplit) {
    return <GroupedAppHeader />;
  }

  return <ClassicAppHeader />;
};

export default AppHeader;
